import { z } from 'zod'

export const LrrReferenceMetadataResponseSchema = z.object({
  s3_path: z.string(),
  slug: z.string(),
  title: z.string(),
  citation: z.string(),
  jurisdiction_code: z.string(),
  doc_type: z.string(), // statute, regulation, rule
  currency: z.string().nullable(), // date the source was refreshed by provider
  effective_date: z.string().nullable(), // date the law was enacted
})
export type LrrReferenceMetadataResponse = z.infer<typeof LrrReferenceMetadataResponseSchema>

export const LrrReferenceHtmlResponseSchema = z.object({
  data: z.string(),
})
export type LrrReferenceHtmlResponse = z.infer<typeof LrrReferenceHtmlResponseSchema>
